// **Ein Build aus der Liste** — die Auswahl in „Versionen" und im Betrieb
// eines Mandanten. Vorausgewählt ist der neueste; der laufende ist markiert.
// Getippt wird nichts (docs/11 12).

import { useState } from "react";
import { useReleases } from "../api/queries";
import { defaultBuild, releaseOptions } from "../lib/releases";
import { ErrorNote, Loading, Note } from "../ui/badge";
import { SelectMenu } from "../ui/select-menu";

export interface BuildChoice {
  query: ReturnType<typeof useReleases>;
  /** Der gewählte Build — leer, solange es keine Liste gibt. */
  value: string;
  setValue: (build: string) => void;
  running: string | null;
}

export function useBuildChoice(running: string | null): BuildChoice {
  const query = useReleases();
  const [picked, setPicked] = useState<string | null>(null);
  const value = picked ?? defaultBuild(query.data?.releases ?? []);
  return { query, value, setValue: setPicked, running };
}

export function BuildSelect({ choice, label = "Build" }: { choice: BuildChoice; label?: string }) {
  const { query } = choice;
  if (query.isPending) return <Loading text="Builds werden gelesen …" />;
  if (query.isError) return <ErrorNote error={query.error} />;
  const { releases, error } = query.data;
  if (!releases.length) {
    return <Note tone="warn">Keine ausrollbaren Builds gefunden{error ? ` (${error})` : ""}. Ist die Pipeline auf main grün und die Registry erreichbar?</Note>;
  }
  return (
    <>
      <SelectMenu
        name="build" ariaLabel={label} className="pf-btn pf-select pf-select--build"
        value={choice.value} options={releaseOptions(releases, choice.running)} onChange={choice.setValue}
      />
      {error ? <Note tone="warn">Liste nicht aktuell: {error}</Note> : null}
    </>
  );
}
